import React from 'react';
import PropTypes from 'prop-types';
import { AlertFilter } from './filters/AlertFilter';
import { ResourceFilter } from './filters/ResourceFilter';
import { ReleaseListFilter } from '@/pages/releases/release-list/ReleaseListFilter';
import { ReleaseCalendarFilter } from '@/pages/releases/calendar/ReleaseCalendarFilter';
import { CommonFilter } from './filters/CommonFilter';

/**
 * Filters Component - Router component that renders appropriate filter based on page
 * @param {Object} props - Component props
 * @param {string} props.page - Page identifier (ALERT_PAGE, RESOURCE_PAGE, etc.)
 * @param {Function} props.hideFilter - Callback to close filter drawer
 * @param {Object} props.filterOptions - Filter options data
 * @return {JSX.Element} Filter panel component
 */
export const Filters = ({ page, hideFilter, filterOptions }) => {
  switch (page) {
    case 'ALERT_PAGE':
      return <AlertFilter hideFilter={hideFilter} />;

    case 'RESOURCE_PAGE':
      return <ResourceFilter hideFilter={hideFilter} />;

    case 'RELEASE_LIST_PAGE':
      return <ReleaseListFilter />;

    case 'RELEASE_CALENDAR_PAGE':
      return <ReleaseCalendarFilter />;

    case 'REGRESSION_DASHBOARD':
      return (
        <CommonFilter hideFilter={hideFilter} filterOptions={filterOptions} />
      );

    default:
      return (
        <div style={{ padding: '20px', textAlign: 'center' }}>
          <p>No filters available for this page.</p>
        </div>
      );
  }
};

Filters.propTypes = {
  page: PropTypes.string.isRequired,
  hideFilter: PropTypes.func,
  filterOptions: PropTypes.object,
};
